// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useMemo, useState } from 'react';
import has from 'lodash/has';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import OfferDetails from '@tcp/core/src/components/common/organisms/OfferDetails';
import DynamicInjectOfferDetails from '@tcp/core/src/components/common/organisms/OfferDetails/container/DynamicInjectOfferDetails.js';
import withStyles from '../../../hoc/withStyles';
import styles, { PromoContainer } from '../styles/Promotions.styles';
import { createPromoArray } from '../../../../../utils';
import PromoMessage from '../atoms/PromoMessage';
import PromotionCheckbox from '../organisms/PromotionCheckbox/views/PromotionCheckbox.view';
import { isSavingCoupon } from '../../../../../utils/utils.web';

export const getUnderLineClass = (isUnderLine) => {
  return isUnderLine === 'true' ? 'underLine' : null;
};

export const isIconVisible = (showIcon) => {
  return showIcon ? 'icon_visible' : 'icon_invisible';
};

export const getMarginTopClass = (index, showHeading) =>
  index > 0 || showHeading ? 'promo-list-item-margin-top' : '';

// Promotions component rendered on PDP/SLP pages.
const Promotions = ({
  isBuyMorePromoEnabled,
  className,
  showHeading,
  serverTime,
  promotionsData,
  trackClickPromotion,
  pageName,
  brand,
  isTileRedesignAB,
  setPromotionPrice,
  isShowPromoPriceMicroData,
  isPDPRedesignPromo,
  applyCoupon,
  removeCoupon,
  isApplyCheckboxPromoOnPdp,
  updateCheckbox,
  couponMap,
  getCartDetailsOnPDP,
  TCPPromotionPrice,
  TCPPromotionID,
  isUpdatedPromotionsDisplayEnabled,
  isOptimizedApplyCouponEnabled,
  isPickupSelectedAtProductDetail,
  TCPPromotionPriceStoreSpecial,
  storeSpecials,
  fromStoreSpecialCaraosal,
  extraStyles,
  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
}) => {
  const isPdp = pageName === 'PDP';
  const isQV = pageName === 'QV';
  const [isOfferDetailsModalActive, setIsOfferDetailsModalActive] = useState(false);
  const [clickedMessage, setClickedMessage] = useState(null);
  const promo = useMemo(() => {
    try {
      if (promotionsData[TCPPromotionID]) {
        return createPromoArray({
          promotionsData,
          serverTime,
          TCPPromotionPrice,
          TCPPromotionID,
          isUpdatedPromotionsDisplayEnabled,
          isOptimizedApplyCouponEnabled,
          isPdp,
          isQV,
          isApplyCheckboxPromoOnPdp,
          TCPPromotionPriceStoreSpecial,
          isPickupSelectedAtProductDetail,
          storeSpecials,
          fromStoreSpecialCaraosal,
        });
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }, [
    promotionsData,
    serverTime,
    TCPPromotionPrice,
    TCPPromotionID,
    isUpdatedPromotionsDisplayEnabled,
    isOptimizedApplyCouponEnabled,
    isPdp,
    isQV,
    isApplyCheckboxPromoOnPdp,
    isPickupSelectedAtProductDetail,
    TCPPromotionPriceStoreSpecial,
    storeSpecials,
  ]);
  useEffect(() => {
    if (isShowPromoPriceMicroData) {
      if (Array.isArray(promo) && promo.length) {
        const promoMessage = promo[0].newPromotionMessage;
        const promoPrice = promoMessage?.price;
        if (promoPrice && setPromotionPrice) {
          setPromotionPrice(promoPrice);
        }
      } else if (setPromotionPrice) {
        setPromotionPrice(null);
      }
    }
  }, [promo]);

  useEffect(() => {
    if (isApplyCheckboxPromoOnPdp) getCartDetailsOnPDP({ promo });
  }, []);

  const appliedCoupons = useMemo(() => {
    if (isApplyCheckboxPromoOnPdp && couponMap) {
      if (Array.isArray(couponMap)) return couponMap;
      return [JSON.parse(couponMap)];
    }
    return null;
  }, [couponMap]);

  const openOfferDetails = async (message) => {
    setClickedMessage(message);
    await DynamicInjectOfferDetails();
    setIsOfferDetailsModalActive(true);
    trackClickPromotion({
      promotion_cd55: pageName,
      promotion_metrics17: 1,
      promotion_cd56: message.promotionMessage,
    });
  };

  function promotionPlacement(promoMessageAB, message, index) {
    let returnBody;
    if (isSavingCoupon(message) && isApplyCheckboxPromoOnPdp && (isPdp || isQV)) {
      return null;
    }
    if (!promoMessageAB || isPdp) {
      returnBody =
        index <= 1 && message?.promotionMessage ? (
          <div className={`promo-list-item${isPDPRedesignPromo ? ' pdp-redesign-promo' : ''}`}>
            <div>
              <BodyCopy
                onClick={() => openOfferDetails(message)}
                anchorVariation="primary"
                fontSizeVariation="medium"
                className={`promo_message_anchor ${getUnderLineClass(message?.clickable)}`}
              >
                <PromoMessage message={message} isPlp={!isPdp} extraStyles={extraStyles} />
              </BodyCopy>
            </div>
          </div>
        ) : null;
    } else {
      returnBody =
        index <= 1 && message?.promotionMessage ? (
          <div>
            <BodyCopy
              onClick={() => openOfferDetails(message)}
              anchorVariation="primary"
              fontSizeVariation="medium"
              className={'promo-ab'}
            >
              <PromoMessage message={message} isPlp={!isPdp} extraStyles={extraStyles} />
            </BodyCopy>
          </div>
        ) : null;
    }
    return returnBody;
  }

  return (
    <>
      {isOfferDetailsModalActive && (
        <OfferDetails
          isOfferDetailsModalActive
          setOfferDetailsModalActive={setIsOfferDetailsModalActive}
          promo={clickedMessage}
          brand={brand}
        />
      )}

      <PromoContainer isApplyCheckboxPromoOnPdp={isApplyCheckboxPromoOnPdp} isPdp={isPdp}>
        {isBuyMorePromoEnabled && promo && promo.length ? (
          <div className={`${className} promo-container`}>
            {showHeading && <div className="promo-list-head" />}
            {promo?.map((message, index) => promotionPlacement(isTileRedesignAB, message, index))}
          </div>
        ) : null}
        {isApplyCheckboxPromoOnPdp && (isPdp || isQV)
          ? promo?.map((message) => {
              const isApplied = appliedCoupons?.some(
                (cachedPromotion) =>
                  has(cachedPromotion, message?.redirectionParameter) ||
                  cachedPromotion?.couponCode === message?.redirectionParameter
              );
              if (isSavingCoupon(message)) {
                return (
                  <PromotionCheckbox
                    coupon={message}
                    applyCoupon={applyCoupon}
                    removeCoupon={removeCoupon}
                    isApplied={isApplied}
                    updateCheckbox={updateCheckbox}
                    isOptimizedApplyCouponEnabled={isOptimizedApplyCouponEnabled}
                  />
                );
              }
              return null;
            })
          : null}
      </PromoContainer>
    </>
  );
};
Promotions.propTypes = {
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  showHeading: PropTypes.bool,
  isBuyMorePromoEnabled: PropTypes.bool,
  promotionsData: PropTypes.shape({}),
  TCPPromotionID: PropTypes.string,
};
Promotions.defaultProps = {
  className: '',
  showIcon: true,
  showHeading: false,
  isBuyMorePromoEnabled: false,
  promotionsData: {},
  TCPPromotionID: '',
};

export default withStyles(Promotions, styles);
export { Promotions as PromotionsVanilla };
